import { createRouter, createWebHistory } from 'vue-router';
import { ensureSession } from '../lib/auth-client.ts';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/learn' },
    { path: '/login', name: 'login', component: () => import('../views/LoginView.vue') },
    {
      path: '/learn',
      name: 'learn',
      component: () => import('../views/LearnView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/progress',
      name: 'progress',
      component: () => import('../views/ProgressView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/sources',
      name: 'sources',
      component: () => import('../views/SourcesView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings/data',
      name: 'settings-data',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/settings/method',
      name: 'settings-method',
      component: () => import('../views/MethodView.vue'),
      meta: { requiresAuth: true },
    },
    { path: '/sources/data', redirect: '/settings/data' },
    {
      path: '/sources/list/:list',
      redirect: (to) => ({ path: '/sources', query: { open: String(to.params.list) } }),
    },
    {
      path: '/sources/list/:list/:band',
      name: 'source-words',
      component: () => import('../views/SourceWordsView.vue'),
      meta: { requiresAuth: true },
    },
    { path: '/about', redirect: '/settings/data' },
    { path: '/:pathMatch(.*)*', redirect: '/learn' },
  ],
});

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true;
  const signedIn = await ensureSession();
  return signedIn ? true : { name: 'login', query: { redirect: to.fullPath } };
});

export { router };
